<small class="debug"> {{me}} </small>
@if (user) {
  <span>
    user exist
  </span>
} @else {
  <app-login [setMode]="'CANVA'"></app-login>
}

